import React from "react";

const DateDivider = ({ label }) => (
    <div
        data-testid="date-divider"
        data-label={label}
        className="flex items-center gap-3 my-2 select-none"
    >
        <span className="flex-1 h-px bg-border/70" />
        <span className="text-[10px] uppercase tracking-[0.14em] font-semibold text-muted-foreground/80 px-2 py-0.5 rounded-full bg-card border border-border/70">
            {label}
        </span>
        <span className="flex-1 h-px bg-border/70" />
    </div>
);

export default DateDivider;
